import { Flex, IconButton } from '@chakra-ui/react';
import { MdEdit } from 'react-icons/md';

import { TableColumn } from '@app/components/common/table';
import { SubcategorySku } from '@app/api/models/sku';

export const useColumns = ({
  onEdit,
  categoriesById,
}: {
  onEdit: (subcategory: SubcategorySku) => void;
  categoriesById: Record<number, string>;
}) => {
  return [
    {
      name: 'id',
      label: '#',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'name',
      label: 'Название',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'category_id',
      label: 'Категория',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value: number) => <span>{categoriesById[value] || '—'}</span>,
      },
    },
    {
      name: 'is_active',
      label: 'Активна',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value: boolean) => <span>{value ? 'Да' : 'Нет'}</span>,
      },
    },
    {
      name: 'id',
      label: 'Действия',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (id, { rowData }) => {
          return (
            <Flex gap={2}>
              <IconButton
                name="edit"
                onClick={() => onEdit(rowData as SubcategorySku)}
                aria-label="edit"
              >
                <MdEdit />
              </IconButton>
            </Flex>
          );
        },
      },
    },
  ] as TableColumn<SubcategorySku>[];
};
